import React, { FunctionComponent } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers";
import AppPage from "./AppPage";

interface ErrorPageProps extends RouteComponentProps {
  pageHeading?: string;
  messageTitle?: string;
  messageText?: string;
  buttonText?: string;
  redirectPath?: string;
}

const ErrorPage: FunctionComponent<ErrorPageProps> = ({
  pageHeading,
  messageTitle,
  messageText,
  buttonText,
  redirectPath,
  history,
}) => {
  const t = useTranslate();
  return (
    <AppPage heading={pageHeading || t("error_page.heading")}>
      <strong className="ds-lead">
        {messageTitle || t("error_page.title")}
      </strong>
      <p>{messageText || t("error_page.message")}</p>
      <Button
        variation="primary"
        onClick={(): void => history.replace(redirectPath || "/")}
      >
        {buttonText || t("error_page.button")}
      </Button>
    </AppPage>
  );
};

export default withRouter(ErrorPage);
